<template>
  <div>
    <v-row align="center" class="mt-1">
      <v-col cols="12" sm="12" md="12" lg="4">
        <v-autocomplete
          v-model="search"
          :items="originalGroupList"
          item-text="positionLvName"
          clearable
          outlined
          dense
          class="mt-2"
          placeholder="ค้นหาจากชื่อระดับตำแหน่ง"
          no-data-text="ไม่พบข้อมูล"
          @keyup="searchTable($event.target.value)"
          @change="filterTable()"
          @click:clear="search = ''"
        >
          <template v-slot:append>
            <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @change="searchFilterData(), page=1">
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="1">
        <v-btn
          class="button-color-outline"
          outlined
          @click="resetFilter()"
        >
          ล้างข้อมูล
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-btn
          class="button-color"
          style="width: 195px; height:36px; border-radius:6px;"
          elevation="0"
          dark
          @click="callDialogAddPositionInGroup()"
        >
          <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
          เพิ่มตำแหน่งในกลุ่ม
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-data-table
          :headers="headers"
          :items="positionGroupList"
          class="border-table-employee"
          :loading="loading"
          loading-text="Loading... Please wait"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100, -1],
            'items-per-page': 15
          }"
          :server-items-length="total || -1"
          @update:items-per-page="changePerPage"
          @update:page="changePage"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
        >
        <template v-slot:[`item.no`]="{ item }">
          {{ (page - 1) * itemsPerPage + positionGroupList.indexOf(item) + 1 }}
        </template>
        <template v-slot:[`item.positionLevel`]="{ item }">
          {{ item.positionLevel ? item.positionLevel : '-' }}
        </template>
        <template v-slot:[`item.data-table-expand`]="{ item }">
          <v-tooltip>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                dark
                icon
                tile
                class="mr-2"
                @click="removePositionGroup(item.id)"
              >
                <template v-slot>
                  <v-icon dark size="20" color="error">mdi-delete-outline</v-icon>
                </template>
              </v-btn>
            </template>
            <span>ลบตำแหน่ง</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-row>
        <v-col cols="12" class="pa-0">
        <div class="justify-end d-flex align-end pt-4">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
          ></v-pagination>
        </div>
        </v-col>
      </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  props: {
    setup: {
      type: null,
      default: null
    },
    loading: {
      type: Boolean,
      default: true
    },
    groupDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      page: 1,
      itemsPerPage: 15,
      pageCount: 0,
      total: -1,
      search: '',
      positionGroupList: [],
      originalGroupList: [],
      headers: [
        { text: 'ลำดับที่', value: 'no', align: 'center', width: '14%' },
        { text: 'ชื่อระดับตำแหน่ง', value: 'positionLvName', align: 'left' },
        { text: 'ระดับตำแหน่ง', value: 'positionLvNumber', align: 'center' },
        { text: 'จัดการ', value: 'data-table-expand', align: 'center', width: '130px' }
      ]
    }
  },
  beforeDestroy () {
    this.search = ''
  },
  methods: {
    changePerPage (value) {
      this.itemsPerPage = value
    },
    changePage (value) {
      this.page = value
    },
    removePositionGroup (id) {
      EventBus.$emit('deletePositionLevelInGroup', id)
    },
    searchTable (value) {
      this.search = value
    },
    filterTable () {
      if (this.search !== '') {
        this.positionGroupList = this.originalGroupList.filter((v) => v.positionLvName === this.search).slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage)
      } else if (!this.search || this.search == null || this.search === '') {
        this.positionGroupList = this.originalGroupList.slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage)
      }
    },
    resetFilter () {
      this.search = ''
      this.filterTable()
    },
    setupTable (value) {
      this.originalGroupList = value
      this.pageCount = Math.ceil(this.originalGroupList.length / this.itemsPerPage)
      this.positionGroupList = this.originalGroupList.slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage)
    },
    callDialogAddPositionInGroup () {
      EventBus.$emit('closeDialog')
      EventBus.$emit('callDialogAddPositionInGroup', this.groupDetail)
    },
    clearSearch () {
      this.search = ''
      EventBus.$emit('clearSearch')
    }
  },
  watch: {
    setup: {
      handler (val) {
        this.setupTable(val)
      },
      immediate: true
    }
  }
}
</script>

<style scoped></style>
